import React from "react";

import withSessionHandling, {
  type SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import OnboardingScreen from "@/screens/Onboarding/OnboardingScreen";

function Screen(props: SessionHandlerProps): React.JSX.Element {
  return <OnboardingScreen {...props} />;
}

export default withSessionHandling(Screen);
